import TimeAgo from "javascript-time-ago";
import es from "javascript-time-ago/locale/es";
import { useEffect, useState } from "react";

let updateTimer;

const SET_TIMEOUT_MAX_SAFE_INTERVAL = 2147483647;
function getSafeTimeoutInterval(interval) {
  return Math.min(interval, SET_TIMEOUT_MAX_SAFE_INTERVAL);
}

function Message({ message, tipo, clase, setImagenActiva }) {
  // TimeAgo.addDefaultLocale(es.locale);
  TimeAgo.addLocale(es);

  const timeAgo = new TimeAgo("es-ES");

  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    render();
    return () => {
      clearTimeout(updateTimer);
    };
  }, []);

  function render() {
    // Format the date.
    const [formattedDate, timeToNextUpdate] = timeAgo.format(new Date(message.instante.seconds * 1000), {
      getTimeToNextUpdate: true,
    });
    // Update the label.
    setFormattedDate(formattedDate);
    // Schedule next render.
    // `timeToNextUpdate` may be `undefined`, so provide a sensible default.
    updateTimer = setTimeout(render, getSafeTimeoutInterval(timeToNextUpdate || 60 * 1000));
  }

  if (tipo === "imagen") {
    return (
      <div className={clase}>
        <div className="message-content">
          <div className="message-text">
            <img
              className="message-image-content"
              src={message.url}
              alt="img"
              onClick={() => {
                setImagenActiva(message.url);
              }}
            />
          </div>
          <div className="message-time">{formattedDate}</div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={clase}>
        <div className="message-content">
          <div className="message-text" style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {message.mensaje}
          </div>
          <div className="message-time">{formattedDate}</div>
        </div>
      </div>
    );
  }
}

export default Message;
